import { normalizeSheetLine } from '@/modules/move/utils/normalizeSheet';
import HttpClientAdapter from '@/shared/services/httpClientAdapter';

import {
  MoveSheet,
  MoveSheetNormalized,
  MoveSheetNormalizedResponse,
  MoveSheetParams,
  MoveSheetResponse,
} from '@/modules/move/entities/interfaces/moveSheet';

class MoveSheetService extends HttpClientAdapter {
  constructor() {
    super('MONITORING');
  }

  getMoveSheet(params: MoveSheetParams) {
    return this.get<MoveSheetNormalizedResponse>('/rows', params, {
      transformResponse: [ this.normalizeMoveSheet ],
    });
  }

  getMoveSheetLine<MoveSheet>(idRow: string) {
    return this.get<MoveSheet>(
      `/rows/${ idRow }`,
      {},
      {
        transformResponse: [ this.normalizeMoveSheetRow ],
      },
    );
  }

  private normalizeMoveSheetRow(response: MoveSheet): MoveSheetNormalized {
    return normalizeSheetLine(response);
  }

  private normalizeMoveSheet(response: MoveSheetResponse) {
    let normalized;
    if (response.page) {
      normalized = response.data.map((line) => normalizeSheetLine(line));
    } else {
      const items = response as unknown as MoveSheet[];
      normalized = items.map((line) => normalizeSheetLine(line));
    }

    if (response.page) {
      return {
        ...response,
        data: normalized,
      };
    }
    return {
      data: normalized,
    };
  }
}

export default MoveSheetService;
